import { render, staticRenderFns } from "./Video_edit.vue?vue&type=template&id=f08d6630&style=true"
import script from "./Video_edit.vue?vue&type=script&lang=js"
export * from "./Video_edit.vue?vue&type=script&lang=js"
import style0 from "./Video_edit.vue?vue&type=style&index=0&id=f08d6630&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports